import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaBorderRadius, YodaColors, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const sideContainerStyleFirstBox: SxProps<Theme> = () => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: YodaJustifyContent.center,
  backgroundColor: YodaColors.white,
  padding: '24px',
  boxShadow: `0px 5px 20px ${YodaColors.gray2}`,
  borderRadius: YodaBorderRadius.medium,
  border: 'none',
  overflow: 'visible',
});

export const sideContainerStyleInnerBox: SxProps<Theme> = () => ({
  '& > div:last-child': {
    marginBottom: YodaSpacing.none,
  },
});
